import { bikes as copy } from "@/lib/copy/bikes";
import { color, font, space, type } from "@/lib/design-tokens";
import { Button, Wrap } from "./primitives";

export function SavingsCallout() {
  return (
    <section data-savings-callout="" style={{ background: color.gold, color: color.onGold }}>
      <Wrap
        padY="clamp(42px,6vw,68px)"
        style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "26px clamp(36px,6vw,80px)" }}
      >
        <div style={{ flex: "1 1 520px" }}>
          <div style={{ fontFamily: font.mono, fontSize: "12px", letterSpacing: ".13em", textTransform: "uppercase", color: color.onGold }}>
            {copy.savingsCallout.eyebrow}
          </div>
          <h2 style={{ margin: "10px 0 0", fontSize: type.h2Tight, fontWeight: 800, lineHeight: 1.15, color: color.ink }}>
            {copy.savingsCallout.heading}
          </h2>
          <p style={{ margin: "12px 0 0", maxWidth: "68ch", fontSize: "16.5px", lineHeight: 1.58 }}>
            {copy.savingsCallout.body}
          </p>
        </div>
        <Button href="/savings" variant="blue" style={{ flex: "0 0 auto", padding: "15px 22px", fontSize: "15px" }}>
          {copy.savingsCallout.action}
        </Button>
      </Wrap>
    </section>
  );
}
